import { createApiAction } from '@saucelabs/sl-util-redux';

import * as actions from './actions';
import { getFilterParamsAdapter, getTimeFilterParams } from './../../api-adapter';
import * as api from './api';
import { loadAggregatedTestNames } from '../test-overview/operations';
import * as constants from './types';

export const getTestNamesByFilter = (payload = {}) => (dispatch) => {
  dispatch(actions.setTestCaseQueryType(payload));
  // TODO: meta can be removed once backend is fixed for TestCases
  return dispatch(loadAggregatedTestNames(payload, { skipErrorPage: true }));
};

export const getTestCaseByName = createApiAction(
  constants.GET_TEST_CASE,
  (payload = {}, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      ...payload,
    };
    return api.getTestCase(params);
  },
);
